var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { IonItem, IonLabel } from '@ionic/react';
import { Controller } from 'react-hook-form';
import { Box, Text } from '@chakra-ui/react';
const StyledFormControl = styled(IonItem) ``;
const StyledFormLabel = styled(IonLabel) ``;
export function IonFormControl(props) {
    const { as = IonItem, assitiveTextContainerProps = { className: 'ion-padding-bottom ion-padding-horizontal' }, assitiveTextProps, children, control, defaultRequiredText = 'Required', errorMessage, helperText, hideAssistiveText, isDisabled, isInvalid, isReadOnly, isRequired, labelProps, labelText, id, requiredComponent = (React.createElement("span", { role: "presentation", "aria-hidden": "true" }, "*")), role = 'group' } = props, otherProps = __rest(props, ["as", "assitiveTextContainerProps", "assitiveTextProps", "children", "control", "defaultRequiredText", "errorMessage", "helperText", "hideAssistiveText", "isDisabled", "isInvalid", "isReadOnly", "isRequired", "labelProps", "labelText", "id", "requiredComponent", "role"]);
    const getCaptionId = () => {
        return `${id}-${errorMessage ? 'errorMessage' : 'helperText'}`;
    };
    const defaultAsstiveTextProps = {
        color: errorMessage && 'var(--ion-color-danger)',
        fontSize: '75% !important',
        id: getCaptionId(),
        pt: 'calc(var(--ion-padding, 16px) / 2)',
    };
    const getAssistiveText = () => {
        if (errorMessage || helperText || isRequired) {
            return (React.createElement(Box, Object.assign({}, assitiveTextContainerProps),
                React.createElement(Text, Object.assign({}, (assitiveTextProps ? assitiveTextProps : defaultAsstiveTextProps)), errorMessage ? errorMessage : isRequired && !helperText ? defaultRequiredText : helperText)));
        }
        return null;
    };
    const getLabelProps = () => {
        if (labelProps) {
            return labelProps;
        }
        if (children.type === 'IonInput' || 'IonTextarea') {
            return { position: 'floating' };
        }
        return null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledFormControl, Object.assign({ as: as, role: role }, otherProps),
            React.createElement(StyledFormLabel, Object.assign({ dataDisabled: isDisabled, dataInvalid: isInvalid, for: id, id: `${id}-label` }, getLabelProps()),
                labelText,
                isRequired && requiredComponent),
            React.createElement(Controller, { control: control, name: id, render: ({ onBlur, onChange, name, value }) => React.cloneElement(children, {
                    ariaDescribedBy: getCaptionId(),
                    ariaInvalid: isInvalid,
                    ariaReadonly: isReadOnly,
                    ariaRequired: isRequired,
                    disabled: isDisabled,
                    id: id,
                    name: name,
                    onIonBlur: onBlur,
                    onIonChange: onChange,
                    readonly: isReadOnly,
                    required: isRequired,
                    value: value,
                }) })),
        !hideAssistiveText && !isReadOnly && getAssistiveText()));
}
//# sourceMappingURL=index.js.map